module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Login","remember_me":"Remember me"},"si":{"title":"ඇතුල් වන්න","remember_me":"මාව මතක තබා ගන්න"}}')
  delete Component.options._Ctor
}
